import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    title: {
        textAlign: "center",
        fontSize: "var(--font-size-display)",
        color: "var(--font-color-display)",
        lineHeight: "70px",
        // marginTop: "25px",
    },
    subTitle: {
        fontWeight: 600,
        fontSize: "var(--font-size-subtitle)",
        lineHeight: "44px",
        marginLeft: "15px",
        textAlign: "left",
        width: "787px",
    },
    customPaper: {
        display: "flex",
        flexDirection: "column",
        gap: "20px",
    },
    element: {
        width: "307px",
        height: "61px",
        boxShadow: "0px 3px 6px #00000029",
        borderRadius: "15px",
        color: "#000000",
        display: "flex",
        alignItems: "center",
        paddingLeft: "5px",
        gap: "50px",
        fontWeight: 600,
        fontSize: "var(--font-size-subtitle)",
        lineHeight: "35px",
    },

    customCard: {
        height: "100px",
        boxShadow: "0px 3px 6px #00000029",
        borderRadius: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "924px",
    },

    mainCard: {
        height: "790px",
        width: "924px",
        borderRadius: "22px 22px 22px 22px",
        boxShadow: "0px 3px 6px #00000059",
        textAlign: "center",
        fontWeight: 600,
        fontSize: "var(--font-size-button)",
        lineHeight: "30px",
        color: "#FFFFFF",
    },

    cardTab: {
        height: "63px",
        background: "#ffffff 0% 0% no-repeat padding-box",
        color: "#000000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "470px",
        boxShadow: "0px 3px 6px #00000029",
        borderRadius: "22px 22px 0px 0px",
    },
    activeCardTab: {
        height: "63px",
        background: "#000000 0% 0% no-repeat padding-box",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "470px",
        boxShadow: "0px 3px 6px #00000029",
        borderRadius: "22px 22px 0px 0px",
    },
    text: {
        fontSize: "var(--font-size-button)",
        lineHeight: "30px",
    },

    allergenCard: {
        fontSize: "var(--font-size-body)",
        lineHeight: "47px",
        width: "260px",
        height: "49px",
        /* boxShadow: "0px 3px 6px #00000029",
             borderRadius: "15px", */
        color: "#000000",
    },
}));
